export default function validationFiltreRenouvellement(filteredByDates, dates, errors) {
  if (filteredByDates && (!dates.dateDebut || !dates.dateFin)) {
    errors.push({
      message: 'listeContratReconductible.filtre.error.filterTypeWithEmptyDate',
    });
    return true;
  }
  if (!filteredByDates && (dates.dateDebut || dates.dateFin)) {
    errors.push({
      message: 'listeContratReconductible.filtre.error.dateWithFilterTypeEmpty',
    });
    return true;
  }
  return false;
}
